import { Reveal, Overline, CTA, MagicImage } from "./primitives";
import { Marquee } from "./Marquee";
import { Quiz } from "./Quiz";

const possibilities = [
  "The ability to travel when you want",
  "Time and space to create",
  "Long, slow mornings with the people you love",
  "Saying \u201cyes\u201d more often, without panic",
  "Leaving survival mode behind",
  "Finally building the life you keep imagining",
];

export const Manifesto = () => (
  <>
    <section id="possibility" data-testid="possibility-section" className="bg-alabaster py-28 md:py-40">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <Reveal>
              <Overline>Possibility</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-8 font-display text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
                This isn't really about money. It's about
                <span className="italic text-terracotta"> who you get to become</span> when money stops being the problem.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-xl font-sans text-lg font-light leading-relaxed text-stonegray">
                Money simply gives you more choices. For you, wealth might look like:
              </p>
            </Reveal>

            <div className="mt-10 border-t border-ink/10 pt-8">
              {possibilities.map((p, i) => (
                <Reveal key={p} delay={i * 0.05}>
                  <div className="flex items-start gap-4 border-b border-ink/8 py-4">
                    <span className="mt-3 h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
                    <span className="font-display text-xl text-ink md:text-2xl">{p}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal className="lg:col-span-5" y={50}>
            <MagicImage
              testid="possibility-image"
              src="/images/broke-mindset.jpg"
              alt="Nichole tearing up a piece of paper that reads broke mindset"
              glow="terracotta"
              speed={50}
              className="aspect-[4/5] w-full"
              imgClassName="rounded-[2px]"
            />
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <p className="mt-16 max-w-2xl font-display text-2xl font-medium leading-snug text-ink md:text-3xl">
            The goal isn't "getting rich." The goal is creating
            <span className="italic text-terracotta"> your version of a wealthy life</span> — and trusting yourself to
            live it.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 max-w-xl font-sans text-lg font-light leading-relaxed text-stonegray">
            As you imagine that life a year from now, you may already be feeling the relief of knowing you're not
            doing it alone.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10"><CTA href="#story" variant="outline" data-testid="possibility-cta">Show me what's possible</CTA></div>
        </Reveal>

        <Reveal delay={0.1}>
          <Quiz />
        </Reveal>
      </div>
    </section>

    <div className="border-y border-ink/8 bg-ivory py-8">
      <Marquee
        testid="possibility-marquee"
        items={["Look what's possible", "More freedom", "More adventure", "More you"]}
      />
    </div>
  </>
);
